import apiCentralSeguranca from '../../api/centralseguranca'

export default {

  state: {
    jwtToken: localStorage.getItem(process.env.VUE_APP_CLIENT_ID) || '',
    status: ''
  },

  mutations: {
    authRequest (state) {
      state.status = 'loading'
    },
    authSuccess (state, payload) {
      state.status = 'success'
      state.jwtToken = payload
    },
    authError (state) {
      state.status = 'error'
    },
    authLogout (state) {
      state.status = ''
      state.jwtToken = ''
    },
    limparJwtTokenState (state) {
      state.jwtToken = ''
      localStorage.removeItem(process.env.VUE_APP_CLIENT_ID)
    }
  },

  getters: {
    isAuthenticated (state) {
      if (state.jwtToken === '') {
        return false
      }
      if ((state.jwtToken)) {
        return true
      } else {
        return false
      }
    },
    authStatus (state) {
      return state.status
    },
    getJwtToken (state) {
      return state.jwtToken
    }
  },

  actions: {
    async authFilter ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('authRequest')
        const localStorageKey = process.env.VUE_APP_CLIENT_ID
        
        let jwtToken = localStorage.getItem(localStorageKey)
        if (jwtToken !== '' && jwtToken !== undefined && jwtToken !== null) {
        } else {
          jwtToken = apiCentralSeguranca.getHashValue('access_token')
        }

        var jwtDecoded = jwtToken == null ? null : apiCentralSeguranca.decodeJwtToken(jwtToken)

        let data = new Date()
        let today = data.getTime().toString()

        if (today.length !== 10) {
          today = today.substr(0, 10)
        }

        if (jwtToken != null && jwtDecoded !== null && jwtDecoded !== undefined && Number.parseInt(today) < jwtDecoded.exp) {
          localStorage.setItem(localStorageKey, jwtToken)
          commit('authSuccess', jwtToken)
          resolve(true)
        } else {
          localStorage.removeItem(localStorageKey)
          reject(new Error('token inválido'))
          window.location.href = '' + apiCentralSeguranca.loginUrl
        }
      })
    },

    authLogout ({ commit }) {
      return new Promise((resolve) => {
        commit('authLogout')
        localStorage.removeItem(process.env.VUE_APP_CLIENT_ID)
        this.$router.push('/')
        resolve(true);
      })
    }

  }
}
